/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-21 13:27:47
 * @LastEditors Cong Yuan wso2848303@163.com
 * @LastEditTime 2025-05-29 17:54:07
 * @Description: 公共页面路由
 * @FilePath: \hsylc2021\src\router\inner\index.js
 */
import TOP_BARS from '@topBars';
import FOOTERS from '@footers';
import Plat from 'utils/plat';
let routes = [
  /**
   * @description + - ✖️ ➗ 内页框架
   * @function /h + - ✖️ ➗ 内页框架
   * @param { Component } Pedagogy views/common/Inner/H/index.vue
   * @param { Name } pathname _
   */
  {
    path: '/inner/h/:symbol',
    name: '_h',
    meta: {
      title: 'H'
    },
    component: () => import('@/views/common/Inner/H/index.vue')
  },
  /**
   * @description 学术评价与收获
   * @function /inner/grades 学术评价与收获
   * @param { Component } Grades views/common/Inner/Grades/index.vue
   * @param { Name } pathname Grades
   */
  {
    path: '/inner/grades',
    name: 'Grades',
    meta: {
      title: '成绩单和荣誉'
    },
    component: () => import('@/views/common/Inner/Grades/index.vue')
  },
  /**
   * @description 学术理念
   * @function /inner/academics 学术理念
   * @param { Component } Academics views/common/Inner/Academics/index.vue
   * @param { Name } pathname Academics
   */
  // {
  //   path: '/inner/academics',
  //   name: 'academics',
  //   meta: {
  //     title: '学术理念'
  //   },
  //   component: () => import('@/views/common/Inner/Academics/index.vue')
  // },
  /**
   * @description 进阶机会
   * @function /inner/advanced 进阶机会
   * @param { Component } advanced views/common/Inner/Advanced/index.vue
   * @param { Name } pathname Advanced
   */
  {
    path: '/inner/advanced',
    name: 'advanced',
    meta: {
      title: '进阶机会'
    },
    component: () => import('@/views/common/Inner/Advanced/index.vue')
  },
  /**
   * @description 毕业研究项目
   * @function /inner/graduation-research 毕业研究项目
   * @param { Component } GraduationResearch views/common/Inner/GraduationResearch/index.vue
   * @param { Name } pathname GraduationResearch
   */
  // {
  //   path: '/inner/graduation-research',
  //   name: 'graduation-research',
  //   meta: {
  //     title: '毕业研究项目'
  //   },
  //   component: () => import('@/views/common/Inner/GraduationResearch/index.vue')
  // },
  /**
   * @description 探索世界名校
   * @function /inner/explore 探索世界名校
   * @param { Component } Explore views/common/Inner/Explore/index.vue
   * @param { Name } pathname Explore
   */
  {
    path: '/inner/explore',
    name: 'explore',
    meta: {
      title: '探索世界名校'
    },
    component: () => import('@/views/common/Inner/Explore/index.vue')
  },
  {
    path: '/inner/haa',
    name: 'haa',
    meta: {
      title: 'HAUSCR校友会'
    },
    component: () => import('@/views/common/Inner/HAA/index.vue')
  },
  /**
   * @description 校友活动
   * @function /inner/alumni-activities 校友活动
   * @param { Component } AlumniActivities views/common/Inner/AlumniActivities/index.vue
   * @param { Name } pathname alumni-activities
   */
  {
    path: '/inner/alumni-activities',
    name: 'alumni-activities',
    meta: {
      title: '校友活动'
    },
    component: () => import('@/views/common/Inner/AlumniActivities/index.vue')
  },
  // /**
  //  * @description 探索世界名校
  //  * @function /inner/community 探索世界名校
  //  * @param { Component } Community views/common/Inner/Community/index.vue
  //  * @param { Name } pathname Community
  //  */
  // {
  //   path: '/inner/community',
  //   name: 'community',
  //   meta: {
  //     title: '校友社群'
  //   },
  //   component: () => import('@/views/common/Inner/Community/index.vue')
  // },
  // /**
  //  * @description 名校校园行
  //  * @function /inner/campus-tour 名校校园行
  //  * @param { Component } CampusTour views/Inner/CampusTour/index.vue
  //  * @param { Name } pathname campus-tour
  //  */
  // {
  //   path: '/inner/campus-tour',
  //   name: 'campus-tour',
  //   meta: {
  //     title: '名校校园行'
  //   },
  //   component: () => import('@/views/common/Inner/CampusTour')
  // },
  /**
   * @description 名校校园行
   * @function /inner/campus-tour 名校校园行
   * @param { Component } CampusTour views/Inner/CampusTour/index.vue
   * @param { Name } pathname campus-tour
   */
  {
    path: '/inner/hxweek',
    name: 'hxweek',
    meta: {
      title: '名校校园行'
    },
    component: () => import('@/views/common/Inner/CampusTour')
  },
  /**
   * @description 学术体系-学术理念
   * @function /academic/pedagogy 学术体系-学术理念
   * @param { Component } Pedagogy views/common/academic/Pedagogy
   * @param { Name } pathname academic-pedagogy
   */
  {
    path: '/academic/pedagogy',
    name: 'academic-pedagogy',
    meta: {
      title: '学术体系-学术理念'
    },
    component: () => import('@/views/common/academic/Pedagogy')
  },
  /**
   * @description 学术体系-核心讲座
   * @function /academic/curriculum 学术体系-核心讲座
   * @param { Compoennt } Cirriculum views/common/academic/Curriculum
   * @param { Name } pathname academic-curriculum
   */
  {
    path: '/academic/curriculum',
    name: 'academic-curriculum',
    meta: {
      title: '学术体系-核心讲座'
    },
    component: () => import('@/views/common/academic/Curriculum')
  },
  /**
   * @description 学术体系-内容领域
   * @function /academic/courses 学术体系-内容领域
   * @param { Component } Courses views/common/academic/Courses
   * @param { Name } pathname academic-courses
   */
  {
    path: '/academic/courses',
    name: 'academic-courses',
    meta: {
      title: '学术体系-内容领域'
    },
    component: () => import('@/views/common/academic/Courses')
  },
  /**
   * @description 学术体系-学者风采
   * @function /academic/instructors 学术体系-学者风采
   * @param { Component } Instructors views/common/academic/Instructors
   * @param { Name } pathname academic-instructors
   */
  {
    path: '/academic/instructors',
    name: 'academic-instructors',
    meta: {
      title: '学术体系-学者风采'
    },
    component: () => import('@/views/common/academic/Instructors')
  },
  /**
   * @description 学术体系-毕业研究课题
   * @function /academic/capstone 学术体系-毕业研究课题
   * @param { Component } Capstone views/common/academic/Capstone
   * @param { Name } pathname academic-capstone
   */
  {
    path: '/academic/capstone',
    name: 'academic-capstone',
    meta: {
      title: '学术体系-毕业研究课题'
    },
    component: () => import('@/views/common/academic/Capstone')
  },
  /**
   * @description 学术体系-影响力论坛
   * @function /academic/IMPACT 学术体系-影响力论坛
   * @param { Component } Impact views/common/academic/Impact
   * @param { Name } pathname academic-impact
   */
  {
    path: '/academic/IMPACT',
    name: 'academic-impact',
    meta: {
      title: '学术体系-影响力论坛'
    },
    component: () => import('@/views/common/academic/Impact')
  },
  /**
   * @description 学术体系-学术评价
   * @function /academic/grades 学术体系-学术评价
   * @param { Component } Grades views/common/academic/Grades
   * @param { Name } pathname academic-grades
   */
  {
    path: '/academic/grades',
    name: 'academic-grades',
    meta: {
      title: '学术体系-学术评价'
    },
    component: () => import('@/views/common/academic/Grades')
  },
  /**
   * @description 申请须知-申请资格
   * @function /instructions/eligibility 申请须知-申请资格
   * @param { Component } Eligibility views/common/instructions/Eligibility
   * @param { Name } pathname instructions-eligibility
   */
  {
    path: '/instructions/eligibility',
    name: 'instructions-eligibility',
    meta: {
      title: '申请须知-申请资格'
    },
    component: () => import('@/views/common/instructions/Eligibility')
  },
  /**
   * @description 申请须知-活动及申请时间
   * @function /instructions/dates 申请须知-活动及申请时间
   * @param { Component } Dates views/common/instructions/Dates
   * @param { Name } pathname instructions-dates
   */
  {
    path: '/instructions/dates',
    name: 'instructions-dates',
    meta: {
      title: '申请须知-活动及申请时间'
    },
    component: () => import('@/views/common/instructions/Dates')
  },
  /**
   * @description 申请须知-申请流程
   * @function /instructions/process 申请须知-申请流程
   * @param { Component } Process views/common/instructions/Process
   * @param { Name } pathname instructions-process
   */
  {
    path: '/instructions/process',
    name: 'instructions-process',
    meta: {
      title: '申请须知-申请流程'
    },
    component: () => import('@/views/common/instructions/Process')
  },
  /**
   * @description 申请须知-费用及助学金
   * @function /instructions/tuition 申请须知-费用及助学金
   * @param { Component } Tuition views/common/instructions/Tuition
   * @param { Name } pathname instructions-tuition
   */
  {
    path: '/instructions/tuition',
    name: 'instructions-tuition',
    disabled: Plat.isAMCSite,
    meta: {
      title: '申请须知-费用及助学金'
    },
    component: () => import('@/views/common/instructions/Tuition')
  },
  // /**
  //  * @description 关于我们-主办机构
  //  * @function /about-us/organization 关于我们-主办机构
  //  * @param { Component } Organization views/common/aboutUs/Organization
  //  * @param { Name } pathname about-us-organization
  //  */
  // {
  //   path: '/about-us/organization',
  //   name: 'about-us-organization',
  //   meta: {
  //     title: '关于我们-主办机构'
  //   },
  //   component: () => import('@/views/common/aboutUs/Organization')
  // },
  /**
   * @description 关于我们
   * @function /about-us 关于我们
   * @param { Component } aboutUs views/common/aboutUs/Partners
   * @param { Name } pathname about-us
   */
  {
    path: '/about-us',
    name: 'about-us',
    meta: {
      title: '关于我们'
    },
    component: () => import('@/views/common/aboutUs/Us')
  },
  /**
   * @description 关于我们-合作院校
   * @function /about-us/partners 关于我们-合作院校
   * @param { Component } Partners views/common/aboutUs/Partners
   * @param { Name } pathname about-us-partners
   */
  {
    path: '/about-us/partners',
    name: 'about-us-partners',
    meta: {
      title: '关于我们-合作院校'
    },
    component: () => import('@/views/common/aboutUs/Partners')
  },
  // /**
  //  * @description 关于我们-顾问委员会
  //  * @function /about-us/advisory-board 关于我们-顾问委员会
  //  * @param { Component } AdvisoryBoard views/common/aboutUs/AdvisoryBoard
  //  * @param { Name } pathname about-us-advisory-board
  //  */
  // {
  //   path: '/about-us/advisory-board',
  //   name: 'about-us-advisory-board',
  //   meta: {
  //     title: '关于我们-顾问委员会'
  //   },
  //   component: () => import('@/views/common/aboutUs/AdvisoryBoard')
  // },
  // /**
  //  * @description 学院和活动-丰富日程
  //  * @function /activities/schedule 学院和活动-丰富日程
  //  * @param { Component } Schedule views/common/activities/Schedule
  //  * @param { Name } pathname activities-schedule
  //  */
  // {
  //   path: '/activities/schedule',
  //   name: 'activities-schedule',
  //   meta: {
  //     title: '学院和活动-丰富日程'
  //   },
  //   component: () => import('@/views/common/activities/Schedule')
  // },
  /**
   * @description 学院和活动-学院生活
   * @function /activities/house 学院和活动-学院生活
   * @param { Component } HouseLife views/common/activities/HouseLife
   * @param { Name } pathname activities-house
   */
  {
    path: '/activities/house',
    name: 'activities-house',
    meta: {
      title: '学院和活动-学院生活',
      footer: FOOTERS.NULL
    },
    component: () => import('@/views/common/activities/HouseLife')
  },
  /**
   * @description 学院和活动-课外活动
   * @function /activities/events 学院和活动-课外活动
   * @param { Component } Events views/common/activities/Events
   * @param { Name } pathname activities-events
   */
  {
    path: '/activities/events',
    name: 'activities-events',
    meta: {
      title: '学院和活动-课外活动'
    },
    component: () => import('@/views/common/activities/Events')
  },
  /**
   * @description 学院和活动-加入HSYLC大家庭
   * @function /activities/community 学院和活动-加入HSYLC大家庭
   * @param { Component } Community views/common/activities/Community
   * @param { Name } pathname activities-community
   */
  {
    path: '/activities/community',
    name: 'activities-community',
    meta: {
      title: '学院和活动-加入HSYLC大家庭'
    },
    component: () => import('@/views/common/activities/Community')
  },
  /**
   * @description 加入我们-未来创始人计划
   * @function /join-us/ffp 加入我们-未来创始人计划
   * @param { Component } FutureFounderProgram views/common/joinUs/FutureFounderProgram
   * @param { Name } pathname future-founders-program
   */
  {
    path: '/join-us/ffp',
    name: 'future-founders-program',
    disabled: Plat.isAMCSite,
    meta: {
      title: '未来创始人计划'
    },
    component: () => import('@/views/common/joinUs/FutureFounderProgram')
  },
  /**
   * @description 加入我们-学生实习生
   * @function /join-us/si 加入我们-学生实习生
   * @param { Component } SI views/common/joinUs/SI
   * @param { Name } pathname csi
   */
  // {
  //   path: '/join-us/si',
  //   name: 'si',
  //   meta: {
  //     title: '加入我们-学生实习生'
  //   },
  //   component: () => import('@/views/common/joinUs/SI')
  // },
  /**
   * @description 加入我们-志愿者
   * @function /join-us/volunteer 加入我们-志愿者
   * @param { Component } Volunteer views/common/joinUs/Volunteer
   * @param { Name } pathname volunteer
   */
  {
    path: '/join-us/volunteer',
    name: 'volunteer',
    disabled: Plat.isAMCSite,
    meta: {
      title: '加入我们-志愿者'
    },
    component: () => import('@/views/common/joinUs/Volunteer')
  },
  /**
   * @description 常见问题
   * @function /faq 常见问题
   * @param { Component } FAQ views/common/FAQ
   * @param { Name } pathname faq
   */
  {
    path: '/faq',
    name: 'faq',
    meta: {
      // title: '常见问题',
      footer: FOOTERS.NULL
    },
    component: () => import('@/views/common/FAQ')
  },
  {
    path: '/psychology/station',
    name: 'psychology-station',
    title: '哈佛HSYLC峰会心理学加油站',
    component: () => import('../../views/student/Psychology/Station')
  },
  /**
   * @description 转线上通知内页 - 不需要登录
   * @function /notice/online-notice-free 录取支付成功页面
   * @param { Component } OnlineNoticeFree /views/Notice/OnlineNoticeFree
   * @param { Name } pathname notice-online-notice-free
   */
  {
    path: '/notice/online-notice-free',
    name: 'notice-online-notice-free',
    meta: {
      title: '2022HSYLC峰会举办形式正式通知'
    },
    component: () => import('@/views/Notice/OnlineNoticeFree')
  },
  {
    path: '/track/ranking',
    name: 'track-ranking',
    meta: {
      title: '2026课程展示'
    },
    component: () => import('views/common/Inner/Track/Ranking')
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: {
      title: '隐私政策'
    },
    component: () => import('views/common/Inner/Privacy')
  },
  {
    path: '/inner/talent-hunt',
    name: 'inner-talent-hunt',
    meta: {
      title: 'HSYLC Talent Hunt校友推荐玩法揭秘'
    },
    component: () => import('views/common/Inner/TalentHunt')
  }
].filter(item => !item.disabled);
routes = routes.map(item => {
  let ret = { ...item };
  ret.meta = {
    topBar: TOP_BARS.INNER,
    footer: FOOTERS.DEFAULT,
    ...ret.meta
  };
  return ret;
});
export default routes;
